import { Alert } from "antd";
import { useAuth } from "../lib/auth";

type Allow = "admin" | "writer" | "any-allowlisted";

interface Props {
  allow: Allow;
  children: React.ReactNode;
  /** Rendered when the current role does not satisfy `allow`. Defaults to a no-access Alert. */
  fallback?: React.ReactNode;
}

const DEFAULT_FALLBACK = (
  <Alert
    type="warning"
    showIcon
    message="Access restricted"
    description="You don't have permission to view this section. Contact an OAIP admin if you think this is a mistake."
  />
);

export default function RoleGate({ allow, children, fallback = DEFAULT_FALLBACK }: Props) {
  const { isAdmin, canWrite, allowlisted } = useAuth();
  const ok =
    allow === "admin"
      ? isAdmin
      : allow === "writer"
        ? canWrite
        : allowlisted;
  return <>{ok ? children : fallback}</>;
}
